import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { APPOINTMENT_TABS, VIEW_KEYS } from '../constants';
import { useAppointmentAnalyticsV2ShallowStore } from '../hooks/use-appointment-analytics-v2-store';
import { ViewRendererProps } from '../types';
import { ScheduleRequestsChart } from './schedule-requests-chart';
import { AppointmentConfirmationChart } from './upcoming-appointments/appointment-confirmation-chart';
import { ProspectPatientList } from './upcoming-appointments/prospect-patient-list';
import { UpcomingAppointmentsDataCards } from './upcoming-appointments/upcoming-appointments-data-cards';
import { AppointmentAnalyticsV2TableView } from './views/table-view';

export const UpcomingAppointmentsTab = (props: ViewRendererProps) => {
  const { aggregatesData, aggregatesDataLoading, containerStyles } = props;
  const { view } = useAppointmentAnalyticsV2ShallowStore('view');

  return (
    <div css={styles.tabContent} style={containerStyles}>
      {view === VIEW_KEYS.TABLE ? (
        <AppointmentAnalyticsV2TableView />
      ) : (
        <>
          <UpcomingAppointmentsDataCards
            aggregatesData={aggregatesData}
            aggregatesDataLoading={aggregatesDataLoading}
          />
          <AppointmentConfirmationChart />
          <ScheduleRequestsChart tab={APPOINTMENT_TABS.UPCOMING} />
          <ProspectPatientList />
        </>
      )}
    </div>
  );
};

const styles = {
  tabContent: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(3)};
  `,
};
